module.exports = __webpack_public_path__ + "thumbnail-cc3af0065d03561b9f67484689d54519.png";